import { render } from "./BidRounds.vue?vue&type=template&id=a1f4d910"
import script from "./BidRounds.vue?vue&type=script&lang=js"
export * from "./BidRounds.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__